import PropTypes from 'prop-types';
import Flatpickr from "react-flatpickr";
import monthSelectPlugin from "flatpickr/dist/plugins/monthSelect";
import { Portuguese } from "flatpickr/dist/l10n/pt.js";

function DataMes({ mes, setData, getUltimoDia }) {

    const handleChange = (data) => {
        if (getUltimoDia) {
            const ultimoDiaDoMes = new Date(data.getFullYear(), data.getMonth() + 1, 0);
            setData(ultimoDiaDoMes)
        } else {
            setData(data)
        }
    };

    return (
        <Flatpickr
            value={mes}
            onChange={(date) => handleChange(date[0])}
            options={{
                disableMobile: true,
                locale: Portuguese,
                plugins: [
                    new monthSelectPlugin({
                        'shorthand': true,
                        'dateFormat': "m/Y",
                        'altFormat': "F Y",
                        'theme': "light"
                    })
                ]
            }}
            className="border p-2 rounded form-control"
        />
    )
}

export default DataMes

DataMes.propTypes = {
    setData: PropTypes.func.isRequired,
    getUltimoDia: PropTypes.bool.isRequired,
};